import axios from 'axios';
const api = axios.create({
    baseURL:'https://us-central1-igneous-effort-268221.cloudfunctions.net'
});
export default api;